import { TranslateModule } from "@ngx-translate/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { MatCheckboxChange, MatCheckboxModule } from "@angular/material/checkbox";
import { Component, ViewEncapsulation, forwardRef, input, output } from "@angular/core";

import { LocalizedNamePipe } from "../../pipes";
import { ReactiveFormsBaseComponent } from "../../base-components";

import { Checkbox } from "src/app/core/interfaces";

@Component({
  selector: "app-checkbox",
  standalone: true,
  imports: [MatCheckboxModule, TranslateModule, LocalizedNamePipe],
  templateUrl: "./checkbox.component.html",
  styleUrl: "./checkbox.component.scss",
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent extends ReactiveFormsBaseComponent {
  readonly label = input.required<string>();
  readonly checked = input(false);
  readonly options = input<Checkbox[]>([]);
  readonly bindValue = input<keyof Checkbox>("id");

  readonly isChecked = output<boolean | Checkbox[]>();

  change(event: MatCheckboxChange, option?: Checkbox) {
    const options = this.options();
    if (options.length) {
      option!.checked = event.checked;
      const checkedOptions = options.filter((each) => each.checked);

      this.control.setValue(checkedOptions.map((checkedOption) => checkedOption[this.bindValue()]));
      this.isChecked.emit(checkedOptions);
    } else {
      this.control.setValue(event.checked);
      this.isChecked.emit(event.checked);
    }
  }
}
